import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import NewsService from '../../services/NewsService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';
import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';
class NewListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new NewsService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
        };

        this.service = new NewsService();
        this.handleChooseExpiredNews = this.handleChooseExpiredNews.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            hideExpired: criteria.hideExpired,
            title: criteria.title,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            hideExpired: false,
            title: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'news.listTitle';
    }
    getCriteriaName() {
        return 'news-list-sc';
    }

    getContainerListName() {
        return 'news-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='text-sc'
                        name='title'
                        label={t('news.title')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.title}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaCheckboxComponent
                        id='checkbox-sc'
                        label={t('news.hideExpired')}
                        name='showExpired'
                        onChange={this.handleChooseExpiredNews}
                        value={this.state.criteria.hideExpired}
                        colClass='col-lg-4 col-sm-6'
                        checked={this.state.criteria.hideExpired}
                    />
                </div>
            </div>
        );
    }

    handleChooseExpiredNews(a, b, c) {
        const check = c.checked;
        this.setState((a) => ({
            criteria: {
                ...a.criteria,
                hideExpired: check,
            },
        }));
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('news.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'status', header: t('news.status'), sortable: true, width: '90px'},
            {field: 'title', header: t('news.title'), sortable: false},
            {
                field: 'activeFrom',
                header: t('news.activeFrom'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeFrom', Constants.DATE_TIME_FORMAT),
            },
            {
                field: 'activeTo',
                header: t('news.activeTo'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeTo', Constants.DATE_TIME_FORMAT),
            },
            {field: 'coinsToEarn', header: t('news.coins'), sortable: true},
            {field: 'action', header: t('global.action'), body: this.actionTemplate, float: 'center'},
        ];
    }

    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
         const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                      className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }
    
    breadCrumbItems() {
        return [{name: t('news.name'), url: '/news-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

NewListContainer.defaultProps = {
    detailUrl: '/news/details',
    newUrl: '/news/create',
    editUrl: '/news/edit',
    lazy: true,
    renderChangeLanguegeFilter: true,
};

NewListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(NewListContainer));
